import { Injectable } from '@angular/core';
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map';
import { environment } from './../../environments/environment';
import { Configurations } from "../core/configurations";
import { DizionarioModel } from './../models/shared/dizionario.model';
import {AuthService} from "./auth.service";

@Injectable()
export class UtilitiesService {

  APIUtenti = this.configuration.apiBaseUrlUtilities;
  MethodLista= "listaComuni";

  constructor(private http: Http, private configuration: Configurations, private authenticationService:AuthService) {

 }

  //lista comuni
  getComuniList(comune: string): Observable<DizionarioModel[]> { 
    return this.http.get(this.APIUtenti + this.MethodLista +"/"+ comune )
    .map((r: Response) => r.json() as DizionarioModel[])  .catch((error: any) => {
      if(error.status === 401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata");
      }
      return Observable.throw(error);
    }
  );
  }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/utilities.service.ts